<template>
  <div class="state-container">
    <div class="img-container">
      <img
        v-if="statusOk"
        class="login-section_logo"
        :src="resolveImage(imgOkIndex)"
        :alt="imgOkAlt"
      />
      <img
        v-else
        class="error-banner"
        src="~@/assets/images/banners/alert.svg"
        alt="Erro"
      />
    </div>
    <div class="msg-container">
      <h1>{{ stateTitle }}</h1>
      <p>{{ stateText }}</p>
      <b-button
        class="button button-secondary"
        v-if="statusOk == false"
        tag="router-link"
        :to="{ name: 'Documentos' }"
      >
        {{ buttonText }}
      </b-button>
      <button
        class="button button-secondary"
        v-else
        @click="$emit('click-button')"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import doctorsImg from '@/assets/images/banners/doctors_banner.svg'
import documentsImg from '@/assets/images/banners/documents-sarah_FormServicos.svg'

export default {
  name: 'StateResponse',
  props: {
    statusOk: {
      type: Boolean,
      default: false
    },
    stateTitle: {
      type: String,
      default: ''
    },
    stateText: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    imgOkIndex: {
      type: Number,
      default: 0
    },
    imgOkAlt: {
      type: String,
      default: 'Doutores'
    }
  },
  methods: {
    resolveImage(index) {
      return index === 0 ? doctorsImg : documentsImg
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/buttons';

.state-container {
  background-color: var(--bg-color-primary);
  margin-top: 1rem;
  max-height: 70vh;
  height: 100%;
  padding: 3.75rem 3.75rem 5.9375rem;
  display: flex;
  justify-content: center;
  .img-container {
    width: 50%;
    img {
      margin: 0 auto;
    }
    .error-banner {
      position: relative;
      top: 5rem;
    }
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .msg-container {
    width: 30%;
    padding-top: 5rem;
    h1 {
      font-size: 2rem;
      font-weight: $font-bold;

      margin-bottom: 2.1875rem;

      color: var(--gray-900);
      line-height: 1;
    }
    p {
      font-size: 1rem;

      color: var(--neutral-color-1);
    }
  }
  .button {
    margin-top: 3.75rem;
    max-width: 12.5rem;
  }
}

@media (max-width: 48rem) {
  .state-container {
    display: block;
    max-height: 100%;
    .img-container {
      width: 100%;
      img {
        display: block;
        top: 0;
      }
    }
    .msg-container {
      width: 100%;
      h1,
      p {
        text-align: center;
      }
      h1 {
        margin: 2.3rem 0 1.5rem;
      }
    }
    .button {
      display: block;
      text-align: center;
      margin-right: auto;
      margin-left: auto;
      span {
        display: block;
        padding-top: 0.35rem;
      }
    }
  }
}
</style>
